/* eslint-disable react/jsx-curly-newline */
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { MdAttachFile } from 'react-icons/md'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import axios from 'axios'
import * as reducks from '../../../reducks'
import routes from '../../../config/routes'
import Flex from '../../commons/Flex/Flex'
import Text from '../../commons/Text/Text'
import DefaultLayout from '../../commons/Layouts/DefaultLayout'
import Breadcrumb from '../../commons/Breadcrumb/Breadcrumb'
import CardContent from '../../commons/CardContent/CardContent'
import LoadingBounce from '../../commons/LoadingBounce/LoadingBounce'
import CardHighlight from '../../commons/CardHighlight/CardHighlight'
import styles from './contentDetail.module.scss'

const initialBreadcrumb = [
  {
    id: 1,
    title: 'Conteúdos',
    path: routes.content.path
  }
]

const ContentDetail = ({ match }) => {
  const { contentId } = match.params
  const dispatch = useDispatch()
  const [breadcrumbs, setBreadcrumbs] = useState(initialBreadcrumb)
  const [disableDownload, setDisableDownload] = useState(false)
  const knowledge = useSelector((state) => state.knowledgeBaseReducer)

  useEffect(() => {
    dispatch(reducks.resources.knowledgeBase.actions.getSelectedItem(contentId))
  }, [contentId])

  useEffect(() => {
    if (
      knowledge.selectedItem.data &&
      !breadcrumbs.find(
        (item) => item.title === knowledge.selectedItem.data.category.name
      )
    ) {
      setBreadcrumbs([
        ...breadcrumbs,
        {
          id: 2,
          title: knowledge.selectedItem.data.category.name
        }
      ])
    }
  }, [knowledge])

  useEffect(() => {
    setBreadcrumbs(initialBreadcrumb)
  }, [])

  const createElementToDownload = (blob, name) => {
    const newUrlFile = window.URL.createObjectURL(blob)
    const element = document.createElement('a')
    element.setAttribute('href', newUrlFile)
    element.setAttribute('download', name)
    element.style.display = 'none'
    document.body.appendChild(element)
    element.click()
    document.body.removeChild(element)
  }

  const donwloadFile = async (file) => {
    if (!file) return
    setDisableDownload(true)

    const { url, name } = file

    try {
      const axiosConfig = {
        responseType: 'blob'
      }

      const { data: blob } = await axios.get(url, axiosConfig)

      createElementToDownload(blob, name)
      setDisableDownload(false)
    } catch (err) {
      setDisableDownload(false)
      if (err.response.status === 404) {
        toast.error('Url do arquivo não encontrada')
        return
      }

      toast.error(
        'Não foi possível realizar o download, por favor tente mais tarde'
      )
    }
  }

  return (
    <DefaultLayout>
      {!knowledge.selectedItem.fetching && knowledge.selectedItem.data && (
        <Flex column>
          <Text
            size="lg"
            color="gray"
            variation="dark"
            extraBold
            lineHeight="30px"
          >
            {knowledge.selectedItem.data.title}
          </Text>

          <Breadcrumb items={breadcrumbs} />

          <div className={styles.container}>
            <div className={styles.list}>
              <CardHighlight
                title={knowledge.selectedItem.data.title}
                sizeTitle="xlg"
                type={knowledge.selectedItem.data.category.code}
                typeText={knowledge.selectedItem.data.category.name}
                variation={knowledge.selectedItem.data.category.code}
                isMarked={knowledge.selectedItem.data.isFavorite}
                className={styles.header}
                classNameTitle={styles.headerTitle}
              />

              <CardContent
                item={{ ...knowledge.selectedItem.data, id: contentId }}
                onPressMarker={() => {
                  dispatch(
                    reducks.resources.knowledgeBase.actions.toggleFavorite({
                      key: knowledge.selectedItem.data.isFeatured
                        ? 'highlights'
                        : 'recents',
                      item: { ...knowledge.selectedItem.data, id: contentId }
                    })
                  ).then(() => {
                    dispatch(
                      reducks.resources.knowledgeBase.actions.getSelectedItem(
                        contentId
                      )
                    )
                  })
                }}
              />
            </div>
            {knowledge.selectedItem.data.attachments.length > 0 && (
              <div className={styles.material}>
                <Text
                  size="lg"
                  extraBold
                  lineHeight="30px"
                  color="gray"
                  variation="dark"
                >
                  Material
                </Text>

                <Text
                  size="sm"
                  color="gray"
                  font="custom"
                  lineHeight="21px"
                  fontWeight="400"
                  margin="24px 0px"
                >
                  {knowledge.selectedItem.data.attachments.length} anexos
                </Text>

                <div className={styles.scrollable}>
                  {knowledge.selectedItem.data.attachments.map((file) => (
                    <div
                      key={file.name}
                      className={styles.materialItem}
                      onClick={() =>
                        !disableDownload ? donwloadFile(file) : () => {}
                      }
                    >
                      <div className={styles.materialItemIcon}>
                        <MdAttachFile color="#4d4d4d" size={20} />
                      </div>
                      <Flex column width="calc(100% - 62px)">
                        <Text
                          size="sm"
                          color="gray"
                          variation="dark"
                          lineHeight="24px"
                        >
                          {file.fileName}
                        </Text>
                        <Text
                          size="xs"
                          color="gray"
                          variation="light"
                          lineHeight="18px"
                          margin="5px 0px 0px 0px"
                        >
                          {file.description}
                        </Text>
                      </Flex>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </Flex>
      )}

      {knowledge.selectedItem.fetching && (
        <div>
          <LoadingBounce />
        </div>
      )}
    </DefaultLayout>
  )
}

ContentDetail.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      contentId: PropTypes.string.isRequired
    })
  }).isRequired
}

export default ContentDetail
